package app.nestbridge.feature.main.navigation

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.slack.circuit.backstack.SaveableBackStack
import com.slack.circuit.backstack.rememberSaveableBackStack
import com.slack.circuit.foundation.NavigableCircuitContent
import com.slack.circuit.foundation.rememberCircuitNavigator
import com.slack.circuit.runtime.screen.PopResult
import com.slack.circuit.runtime.screen.Screen

@Composable
fun TabHost(
    root: Screen,
    init: SaveableBackStack.() -> Unit = {},
    modifier: Modifier = Modifier,
    onRootPop: (result: PopResult?) -> Unit,
) {
    val backStack = rememberSaveableBackStack(root, init)
    val navigator = rememberCircuitNavigator(backStack, onRootPop)

    NavigableCircuitContent(
        navigator = navigator,
        backStack = backStack,
        modifier = modifier,
    )
}
